module.exports = __webpack_public_path__ + "img/TM-Dev42.595ddcdc.png";